import { gql } from "@apollo/client";

const UPDATE_PLATEFORM = gql`
  mutation updatePlatform(
    $platformPublicId: String!
    $title: String
    $platformType: String!
    $country: String!
    $language: String
    $timeZone: String
    $currency: String
    $description: String
    $alreadyDomain: Boolean
    $platformLink: String
    $domain: String
    $companyName: String
    $registrationNumber: String
    $fullAddress: String
    $companyEmail: String
    $needLanding: Boolean
    $needIntegration: Boolean
    $onlinePayment: Boolean
    $licenseMemberships: Boolean
    $signeeRole: String
    $signeeFullName: String
    $onlinePayments: Boolean
    $onlineBookingCourts: Boolean
    $liveStreaming: Boolean
    $liveScoring: Boolean
    $serviceProvider: String
    $primaryColor: String
    $secondaryColor: String
    $darkLogo: Upload
    $lightLogo: Upload
    $darkEmblem: Upload
    $lightEmblem: Upload
    $favicon: Upload
    $yourRequest: String
    $uploadFile: Upload
    $mobileApp: Boolean
    $smm: Boolean
    $graphicsForSmm: Boolean
    $template: Int
    $disciplines: [Int!]
    $isEnablePrice: Boolean
    $thirdPartyLicenses: [Int!]
    $tournatedEntryFee: Float
    $partnerEntryFee: Float
    $tournatedLicenseFee: Float
    $partnerLicenseFee: Float
    $status: String
    $updateCustomEntryFeeInput: [UpdatePlatformFeeInput!]
    $updateCustomLicenseFeeInput: [UpdatePlatformFeeInput!]
    $isAlreadyCreated: Boolean
    $landingLink: String
    $isEnableMaintenance: Boolean
    $passcode: String
    $maintenanceDescription: String
    $maintenanceTitle: String
    $abbreviation: String
    $isMobileAppSupported: Boolean
    $subDomain: String
    $liveStreaming_sporfie_key: String
    $isTournatedFeeVatEnable: Boolean
    $tournatedFeeVat: Float
    $overrideOrganizationsFees: Boolean
    $overrideLeagueFees: Boolean
  ) {
    updatePlatform(
      updatePlatformInput: {
        platformPublicId: $platformPublicId
        title: $title
        platformType: $platformType
        signeeRole: $signeeRole
        signeeFullName: $signeeFullName
        country: $country
        language: $language
        timeZone: $timeZone
        currency: $currency
        description: $description
        alreadyDomain: $alreadyDomain
        platformLink: $platformLink
        primaryColor: $primaryColor
        secondaryColor: $secondaryColor
        uploadFile: $uploadFile
        yourRequest: $yourRequest
        lightEmblem: $lightEmblem
        darkEmblem: $darkEmblem
        lightLogo: $lightLogo
        darkLogo: $darkLogo
        favicon: $favicon
        serviceProvider: $serviceProvider
        liveScoring: $liveScoring
        liveStreaming: $liveStreaming
        onlineBookingCourts: $onlineBookingCourts
        onlinePayments: $onlinePayments
        licenseMemberships: $licenseMemberships
        onlinePayment: $onlinePayment
        needIntegration: $needIntegration
        needLanding: $needLanding
        companyEmail: $companyEmail
        fullAddress: $fullAddress
        registrationNumber: $registrationNumber
        companyName: $companyName
        domain: $domain
        mobileApp: $mobileApp
        smm: $smm
        graphicsForSmm: $graphicsForSmm
        template: $template
        disciplines: $disciplines
        isEnablePrice: $isEnablePrice
        thirdPartyLicenses: $thirdPartyLicenses
        tournatedEntryFee: $tournatedEntryFee
        partnerEntryFee: $partnerEntryFee
        tournatedLicenseFee: $tournatedLicenseFee
        partnerLicenseFee: $partnerLicenseFee
        status: $status
        landingLink: $landingLink
        isEnableMaintenance: $isEnableMaintenance
        passcode: $passcode
        maintenanceDescription: $maintenanceDescription
        maintenanceTitle: $maintenanceTitle
        abbreviation: $abbreviation
        isMobileAppSupported: $isMobileAppSupported
        subDomain: $subDomain
        liveStreaming_sporfie_key: $liveStreaming_sporfie_key
        isTournatedFeeVatEnable: $isTournatedFeeVatEnable
        tournatedFeeVat: $tournatedFeeVat
      }
      updateCustomEntryFeeInput: $updateCustomEntryFeeInput
      updateCustomLicenseFeeInput: $updateCustomLicenseFeeInput
      isAlreadyCreated: $isAlreadyCreated
      overrideOrganizationsFees: $overrideOrganizationsFees
      overrideLeagueFees: $overrideLeagueFees
    ) {
      id
      title
      platformType
      country
      language
      timeZone
      currency
      description
      alreadyDomain
      primaryColor
      secondaryColor
      uploadFile
      yourRequest
      coverPhoto
      lightLogo
      darkLogo
      serviceProvider
      liveScoring
      liveStreaming
      onlineBookingCourts
      onlinePayments
      licenseMemberships
      onlinePayment
      needIntegration
      needLanding
      companyEmail
      fullAddress
      registrationNumber
      companyName
      domain
      signeeFullName
      signeeRole
      graphicsForSmm
      smm
      mobileApp
      liveStreaming_sporfie_key
      isTournatedFeeVatEnable
      tournatedFeeVat
    }
  }
`;

export default UPDATE_PLATEFORM;
